import React from 'react'
import styled from 'styled-components'
import Wave from './Wave';

const SectionGroup = styled.div`
    background: url(${props => props.image});
    background-position: 80% 50%;
    /* background-position: bottom; */
   /* height: 900px; */
    height: 820px;
    background-size: cover;
    display: grid;
    grid-template-rows: 300px auto;
    grid-gap: 20px;
    position: relative;
    /* Additional */
    margin: 100px 0 0;
    padding: 150px 0 150px;    
    justify-items: center;
    @media (max-width: 640px) {
        /*height: 820px;*/
        height: 1370px;
        background-position: 71% 50%;
        margin: 0;
        padding: 0 0 50px;
    }
    @media (min-width: 640px) and (max-width: 1124px) {
        background-position: 71% 50%;
        height: 110vh;
    }

    @media (min-width: 1124px) and (max-width: 1300px) {
        height: 150vh;
        margin-top: 0;
    }
`

const SectionLogo = styled.img`
    align-self: end;
    width: 128px;
    margin: 0 auto;
`

const SectionTitleGroup = styled.div`
    display: grid;
    grid-template-columns: 300px auto;
    /* grid-template-columns: repeat(2, 1fr); */
    margin: 0 40px;
    grid-gap: 8rem;
    grid-template-rows: auto 100%;
    /* Additional */
    max-width: 60vw;
    align-items: start;
    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
     @media (min-width: 640px) and (max-width: 1124px) {
        display: inline-block;
    }
`

const SectionTitle = styled.h3`
    color: #252a2b;
    font-size: 54px;
    margin: 0;
    line-height: 1.2;
    @media (max-width: 720px) {
        font-size: 40px;
    }
    @media (max-width: 1124px) {
        color: #F2F2F7;
        mix-blend-mode: exclusion;
    }
`

const SectionText = styled.div`
    color: #F2F2F7;
    mix-blend-mode: exclusion;
    line-height: 1.5;
`

const SectionLink = styled.div`
    display: grid;
    grid-template-rows: 40px 1rem;
    margin: -130px auto 0;
    /* margin: -150px auto 0; */
    position: relative;
    /* Additional */
    justify-items: center;
     @media (max-width: 640px) {
        margin: 0;
    }
    @media (min-width: 640px) and (max-width: 1124px) {
        margin-top: -80px;
    }
    `

const WaveBottom = styled.div`
    position: absolute;
    width: 100%;
    bottom: -8px;
    @media (max-width: 640px) {
svg {
    height: 50px!important;
  }
}
`

const WaveTop = styled.div`
    position: absolute;
    width: 100%;
    top: -8px;
    transform: rotate(180deg);
        @media (max-width: 640px) {
svg {
    height: 50px!important;
  }
}
`

const Section = props => (
    <SectionGroup image={props.image}>
        <WaveTop><Wave /></WaveTop>
        <WaveBottom><Wave /></WaveBottom>
        <SectionLogo src={props.logo} />
        <SectionTitleGroup>
            <SectionTitle>{props.title}</SectionTitle>
            <SectionText>
                <div>Russian is recommended itself not only as the member of so-called world capital eight but also as a language of literature, the establishment of diplomatic relations, etc.</div>
                <div>The preference of the academic or special professional purposes-oriented course manner of the representation of information; preparation for TORFL (TRKI) or entertainment form (studying through classic Russian films, daily dialogues, etc.) are the sphere of the Student demands.</div>
            </SectionText>
            {/* <SectionLink>{props.link} <a href="https://linglab.eu/contact-us" className="active"></a></SectionLink> */}
            {/* <Link to="/" activeClassName="link__active">Learn More</Link> */}
        </SectionTitleGroup>
        <SectionLink><a href="/#Contact" className="CoursesLinks">Learn more</a></SectionLink>
    </SectionGroup>
)

export default Section